/**
 * Created by alvinoktavianus on 5/18/17.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import LoadingSpinner from 'components/LoadingSpinner';
import Header from '../Header';
import styles from './CurrentPlan.css';

class CurrentPlan extends Component {
  calculateDaysLeft = expiredAt => {
    const calculatedDaysLeft = Math.ceil(
      moment(expiredAt).diff(moment(), 'hours') / 24
    );
    const currentDaysInMonth = moment().daysInMonth();
    let daysLeft = 0;
    if (calculatedDaysLeft > currentDaysInMonth) {
      daysLeft = currentDaysInMonth;
    } else {
      daysLeft = calculatedDaysLeft;
    }
    return daysLeft;
  };

  render() {
    const {
      currentSubscriptionPlanName,
      showLoadingSpinnerPage,
      isEnterprise,
      expiredAt,
      isMokaposUser,
    } = this.props;
    const lastPaymentDate = this.props.last_payment_date;
    const daysLeft = this.calculateDaysLeft(expiredAt);
    return (
      <div className={styles['current-plan-section']}>
        <Header title="current plan" />
        <div className={styles['loading-plan']}>
          <LoadingSpinner showLoadingSpinner={showLoadingSpinnerPage} />
        </div>
        {!showLoadingSpinnerPage && (
          <div className={styles['mb-30px']}>
            <div className={styles['mb-10px']}>
              Your current subscription plan:{' '}
              <strong
                className={
                  currentSubscriptionPlanName === 'Expired'
                    ? styles['is-expired']
                    : ''
                }
              >
                {isEnterprise
                  ? 'Moka Enterprise'
                  : isMokaposUser
                  ? currentSubscriptionPlanName === 'Trial'
                    ? `Moka POS Trial ${Math.min(14, daysLeft)} Days`
                    : currentSubscriptionPlanName
                  : 'MokaPay'}
              </strong>
            </div>
            <div>
              Last Payment:{' '}
              {isMokaposUser ? (
                <strong>
                  {lastPaymentDate
                    ? moment(lastPaymentDate).format('DD MMMM YYYY')
                    : 'N/A'}
                </strong>
              ) : (
                'N/A'
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { currentSubscriptionPlanName } = state.setting.billing;
  const {
    last_payment_date,
    is_enterprise,
    expired_at: expiredAt,
    is_mokapos_user: isMokaposUser,
  } = state.moka.user.business;
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    last_payment_date,
    currentSubscriptionPlanName,
    showLoadingSpinnerPage,
    isEnterprise: is_enterprise,
    expiredAt,
    isMokaposUser,
  };
}

const connected = connect(mapStateToProps)(CurrentPlan);

export default connected;
